import { RegistryItem } from "@schemas/agreements/schema";
import { AgreementTypeEnum, CalculationMethodType, DemurrageCalculationUnit, DemurrageCalculationRoundingRule, CallType } from "__generated__/graphql";
import { DemurrageCalculationPeriodRegime } from "__generated__/enums";

export const DemurrageCalculationSchema: RegistryItem = {
	[AgreementTypeEnum.DemurrageCalculation]: {
		defaultValues: {
			calculationMethod: {
				type: CalculationMethodType.DemurrageCalculation,
				demurrageCalculationUnit: DemurrageCalculationUnit.Hour,
				laytimePeriodRegime: DemurrageCalculationPeriodRegime.Sshinc,
				laytimeRoundingRule: DemurrageCalculationRoundingRule.None,
				defaultCargoActionTypes: [ CallType.NitrogenPurging, CallType.Loading, CallType.Discharging, CallType.Cleaning ],
			},
		},
		agreementFields: {
			"agreement.costType": { rules: { hidden: true } },
			"agreement.description": { rules: { hidden: true } },
		},
	},
};
